import { Routes, Route } from "react-router-dom";
import AnalyzeResumes from "./Pages/AnalyzeResumes/AnalyzeResumes";
import RootLayout from "./layouts/RootLayout";
import UserLayout from "./layouts/UserLayout";
import "./cvanalyzerapp.css";


export default function CVAnalyzerApp() {
  return (
    <div className="cv-analyzer-theme">
      <RootLayout>
        <Routes>
          <Route element={<UserLayout />}>
            <Route path="/" element={<AnalyzeResumes />} />
          </Route>
        </Routes>
      </RootLayout>
    </div>
  );
}
